/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getBrand = /* GraphQL */ `
  query GetBrand($id: ID!) {
    getBrand(id: $id) {
      id
      brandmanagers
      name
      image
      security_role_title
      store_manager_role_title
      createdAt
      updatedAt
    }
  }
`;
export const listBrands = /* GraphQL */ `
  query ListBrands(
    $filter: ModelBrandFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBrands(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        brandmanagers
        name
        image
        security_role_title
        store_manager_role_title
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStore = /* GraphQL */ `
  query GetStore($id: ID!) {
    getStore(id: $id) {
      id
      storemanagers
      security
      name
      open_time_mon
      close_time_mon
      open_time_tue
      close_time_tue
      open_time_wed
      close_time_wed
      open_time_thu
      close_time_thu
      open_time_fri
      close_time_fri
      open_time_sat
      close_time_sat
      open_time_sun
      close_time_sun
      address
      lat
      lng
      num_persons
      duration
      timezone
      phone
      minutes_before_out
      minutes_before_expire
      brand_id
      locked
      currentlyInStore
      createdAt
      updatedAt
    }
  }
`;
export const listStores = /* GraphQL */ `
  query ListStores(
    $filter: ModelStoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStores(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storemanagers
        security
        name
        open_time_mon
        close_time_mon
        open_time_tue
        close_time_tue
        open_time_wed
        close_time_wed
        open_time_thu
        close_time_thu
        open_time_fri
        close_time_fri
        open_time_sat
        close_time_sat
        open_time_sun
        close_time_sun
        address
        lat
        lng
        num_persons
        duration
        timezone
        phone
        minutes_before_out
        minutes_before_expire
        brand_id
        locked
        currentlyInStore
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDashboardStoreStat = /* GraphQL */ `
  query GetDashboardStoreStat($id: ID!) {
    getDashboardStoreStat(id: $id) {
      id
      dptype
      store_id
      dpindex
      completed
      cancelled
      active
      duration
      favorites
      first
      createdAt
      updatedAt
    }
  }
`;
export const listDashboardStoreStats = /* GraphQL */ `
  query ListDashboardStoreStats(
    $filter: ModelDashboardStoreStatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDashboardStoreStats(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dptype
        store_id
        dpindex
        completed
        cancelled
        active
        duration
        favorites
        first
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReservation = /* GraphQL */ `
  query GetReservation($id: ID!) {
    getReservation(id: $id) {
      id
      store_id
      owner
      iscancelled
      enterdt
      leavedt
      dt
      first
      createdAt
      updatedAt
    }
  }
`;
export const listReservations = /* GraphQL */ `
  query ListReservations(
    $filter: ModelReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReservations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        store_id
        owner
        iscancelled
        enterdt
        leavedt
        dt
        first
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFavorite = /* GraphQL */ `
  query GetFavorite($id: ID!) {
    getFavorite(id: $id) {
      id
      store_id
      owner
      createdAt
      updatedAt
    }
  }
`;
export const listFavorites = /* GraphQL */ `
  query ListFavorites(
    $filter: ModelFavoriteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFavorites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        store_id
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($owner: String!) {
    getUserInfo(owner: $owner) {
      createdAt
      email
      owner
      phone
      countryShortCode
      receiveEmail
      receivePush
      receiveSMS
      updatedAt
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $filter: TableUserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        email
        owner
        phone
        countryShortCode
        receiveEmail
        receivePush
        receiveSMS
        updatedAt
      }
      nextToken
    }
  }
`;
export const queryUserInfosByMobileIndex = /* GraphQL */ `
  query QueryUserInfosByMobileIndex(
    $phone: AWSPhone!
    $first: Int
    $after: String
  ) {
    queryUserInfosByMobileIndex(phone: $phone, first: $first, after: $after) {
      items {
        createdAt
        email
        owner
        phone
        countryShortCode
        receiveEmail
        receivePush
        receiveSMS
        updatedAt
      }
      nextToken
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js